import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Grid,
  GridItem,
  Text,
  Image,
  IconButton,
} from "@chakra-ui/react";
import { BiChevronRight, BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const samplepics = [
  "/images/lightgrey.png",
  "/images/grey.png",
  "/images/lightgrey.png",
  "/images/grey.png",
  "/images/lightgrey.png",
  "/images/grey.png",
];

interface SlidehowProps{
  pics: string[]
}
export default function Slideshow(props: SlidehowProps) {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  function forward() {
    setIndex(index + 1);
    if (index >= props.pics.length - 1) setIndex(0);
  }
  function backward() {
    setIndex(index - 1);
    if (index < 0) setIndex(props.pics.length - 1);
  }

  return (
    <Flex
    my="1rem"
      w="100%"
      alignItems={"center"}
      justifyContent={"center"}
      flexDir={"column"}
    >
      <Flex justifyContent={"center"} alignItems={"center"} mb="2rem">
        <IconButton
          icon={<BiChevronLeft size={"2rem"} fill="white" />}
          aria-label={""}
          bg="transparent"
          _hover={{ bg: "none" }}
          onClick={backward}
        ></IconButton>
        <Image
          objectFit="contain"
          h="25rem"
          w="32rem"
          src={props.pics[index]}
          zIndex="1"
          borderRadius={"1rem"}
        />
        <IconButton
          icon={<BiChevronRight size={"2rem"} fill="white" />}
          aria-label={""}
          bg="transparent"
          _hover={{ bg: "none" }}
          onClick={forward}
        ></IconButton>
      </Flex>
    </Flex>
  );
}
